import React,{useState} from 'react';
import {NavLink, Link} from 'react-router-dom';
import {FiAlignRight,FiXCircle,FiChevronDown } from "react-icons/fi";
import './NavBar.css';

const MenuNavBar = () => {
    const [isMenu, setisMenu] = useState(false);
    const [isResponsiveclose, setResponsiveclose] = useState(false);
    const toggleClass = () => {
      setisMenu(isMenu === false ? true : false);
      setResponsiveclose(isResponsiveclose === false ? true : false);
    };
    let boxClass = ["main-menu"];
    if(isMenu) {
        boxClass.push('menuq2');
    }else{
        boxClass.push('');
    }

    return (
      <div className="header__middle">
        <div className="head-container">
            <div className="header__middle__menus">
              <nav className="main-nav ">
                {/* Responsive Menu Button */}
                {isResponsiveclose === true ? (
                  <>
                    <span
                      className="menubar__button"
                      style={{ display: "none" }}
                      onClick={toggleClass}
                    >
                      {" "}
                      <FiXCircle />{" "}
                    </span>
                  </>
                ) : (
                  <>
                    <span
                      className="menubar__button"
                      style={{ display: "none" }}
                      onClick={toggleClass}
                    >
                      {" "}
                      <FiAlignRight />{" "}
                    </span>
                  </>
                )}
                <ul className={boxClass.join(" ")}>
                  <li className="menu-item">
                    <NavLink
                      onClick={toggleClass}
                      activeClassName="is-active"
                      className="nav-links"
                      to="/home"
                      exact
                    >
                     Home
                    </NavLink>
                  </li>
                  <li className="menu-item">
                  <a href='https://atci.lkm.delivery.accenture.com/leadershipprograms/home' activeClassName='is-active' className="nav-links" onClick={toggleClass} target="_blank" >Leadership Programs</a>
                  
                  </li>
                  <li className="menu-item">
                  <a href='https://atci.lkm.delivery.accenture.com/Agile/' activeClassName='is-active' className="nav-links" onClick={toggleClass} target="_blank" >Agile</a>
                  
                  </li>
                  <li className="menu-item">
                  <a href='https://atci.lkm.delivery.accenture.com/DevOps/' activeClassName='is-active' className="nav-links" onClick={toggleClass} target="_blank" >DevOps</a>
                  </li>
                  <li className="menu-item">
                  <a href='https://atci.lkm.delivery.accenture.com/TT/' activeClassName='is-active' className="nav-links" onClick={toggleClass} target="_blank" >IE</a>
                  </li>
                  <li className="menu-item">
                  <a href='https://atci.lkm.delivery.accenture.com/TechCore/' activeClassName='is-active' className="nav-links" onClick={toggleClass} target="_blank" >Tech Core</a>
                  </li>
                  <li className="menu-item">
                  <a href='https://atci.lkm.delivery.accenture.com/SRE/' activeClassName='is-active' className="nav-links" onClick={toggleClass} target="_blank" >SRE</a>
                  </li>
                  <li className="menu-item">
                  <a href='https://atci.lkm.delivery.accenture.com/DLF/' activeClassName='is-active' className="nav-links" onClick={toggleClass} target="_blank" >DFA</a>
                  </li>
                  <li className="menu-item">
                  <a href='https://atci.lkm.delivery.accenture.com/SystemIntegration/' activeClassName='is-active' className="nav-links" onClick={toggleClass} target="_blank" >SI</a>
                  </li>
                  <li className="menu-item">
                  <a href='https://atci.lkm.delivery.accenture.com/ApplicationManagementServices/home' activeClassName='is-active' className="nav-links" onClick={toggleClass} target="_blank" >AMS</a>
                  </li>
                 
                    <li className="menu-item">
                  <a href='https://atci.lkm.delivery.accenture.com/ProjectManagement/' activeClassName='is-active' className="nav-links" onClick={toggleClass} target="_blank" >PM</a>
                  </li>
                 

                
                </ul>
              </nav>
            </div>
        </div>
      </div>
    );
}

export default MenuNavBar;
